"use strict";

var Paypal = require('./paypal/paypal');
var ApplePay = require('./applepay/applepay');
var GooglePay = require('./googlepay/googlepay');
var AmazonPay = require('./amazonpay/amazonPayExpressPart1');
var expressPaymentMethods = {
  Paypal: Paypal,
  ApplePay: ApplePay,
  GooglePay: GooglePay,
  AmazonPay: AmazonPay
};
module.exports = expressPaymentMethods;